import * as React from 'react';
import { Input as AntInput } from 'antd';
import { InputProps as AntInputProps } from 'antd/lib/input';

export type InputProps = {
  id?: string;
  size: 'large' | 'middle' | 'small';
  placeholder?: string;
  value?: string;
  disabled: boolean;
  maxLength?: number;
  onPressEnter?: () => void;
  prefix?: string | React.ReactNode;
  allowClear: boolean;
  border?: boolean;
};

const Input = (props: InputProps & AntInputProps) => {
  const { className, border } = props;
  const classNames = [className, 'input'];
  if (border) {
    classNames.push('border');
  }
  return <AntInput {...props} className={classNames.join(' ')} />;
};

Input.defaultProps = {
  defaultValue: '',
  disabled: false,
  size: 'middle',
  allowClear: true,
  border: false,
};

export default Input;
